document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.aura-showcase');

  const debounce = (fn, t = 120) => {
    let id;
    return (...a) => { clearTimeout(id); id = setTimeout(() => fn(...a), t); };
  };

  sections.forEach(section => {
    const ul = section.querySelector('.aura-picker');
    if (!ul) return;

    const productWraps = Array.from(section.querySelectorAll('.aura-products'));
    const byHandle = new Map(productWraps.map(w => [w.dataset.collectionHandle, w]));

    const setActive = (handle) => {
      productWraps.forEach(w => w.classList.toggle('is-active', w.dataset.collectionHandle === handle));
      const all = ul.querySelectorAll('.aura-picker__item');
      all.forEach(li => li.setAttribute('aria-selected', li.dataset.collectionHandle === handle ? 'true' : 'false'));
    };

    const centerItem = (li) => {
      // nur auf Handy zentrieren (Desktop >=1024 nicht)
      if (window.matchMedia('(min-width:1024px)').matches) return;
      const target = li.offsetTop - (ul.clientHeight / 2) + (li.clientHeight / 2);
      ul.scrollTo({ top: target, behavior: 'smooth' });
    };

    // ---------- Infinite Wheel (nur Handy) ----------
    const getItemHeight = () => {
      const probe = ul.querySelector('.aura-picker__item');
      return probe ? probe.getBoundingClientRect().height : 48;
    };

    const refreshItemListeners = () => {
      ul.querySelectorAll('.aura-picker__btn').forEach(btn => {
        if (btn._handlerClick) btn.removeEventListener('click', btn._handlerClick);
        const handler = (e) => {
          e.preventDefault(); e.stopPropagation();
          const li = btn.closest('.aura-picker__item');
          if (!li) return;
          const handle = li.dataset.collectionHandle;
          if (!byHandle.has(handle)) return;
          setActive(handle);
          centerItem(li);
        };
        btn._handlerClick = handler;
        btn.addEventListener('click', handler);
      });
    };

    const buildInfiniteWheel = () => {
      if (ul.dataset.infinite === '1') return; // schon gebaut

      const items = Array.from(ul.querySelectorAll('.aura-picker__item'));
      if (items.length === 0) return;

      const fragHead = document.createDocumentFragment();
      const fragTail = document.createDocumentFragment();
      items.forEach(li => fragHead.appendChild(li.cloneNode(true)));
      items.forEach(li => fragTail.appendChild(li.cloneNode(true)));
      ul.insertBefore(fragHead, ul.firstChild);
      ul.appendChild(fragTail);
      ul.dataset.infinite = '1';

      refreshItemListeners();

      // Startposition: mittlerer Satz
      const padTop = parseInt(getComputedStyle(ul).paddingTop) || 0;
      const h = getItemHeight();
      const count = items.length;
      const total = h * count;
      ul.scrollTop = padTop + total;
    };
    // ------------------------------------------------

    // Erst-Listener setzen
    refreshItemListeners();

    // Scroll-Logik: aktives Item + Loop-Warp
    const onScroll = debounce(() => {
      const isMobile = window.matchMedia('(max-width:1023px)').matches;
      const all = Array.from(ul.querySelectorAll('.aura-picker__item'));
      if (all.length === 0) return;

      // aktives Element in der Mitte finden
      const mid = ul.scrollTop + ul.clientHeight / 2;
      let best = null, dist = Infinity;
      all.forEach(li => {
        const liMid = li.offsetTop + li.clientHeight / 2;
        const d = Math.abs(liMid - mid);
        if (d < dist) { dist = d; best = li; }
      });
      if (best) {
        const handle = best.dataset.collectionHandle;
        if (byHandle.has(handle)) setActive(handle);
      }

      // Loop nur auf Handy
      if (!isMobile || ul.dataset.infinite !== '1') return;

      const padTop = parseInt(getComputedStyle(ul).paddingTop) || 0;
      const h = getItemHeight();
      const originalCount = all.length / 3; // weil 1x oben + 1x unten geklont
      const total = h * originalCount;
      const startMid = padTop + total;     // Beginn mittlerer Satz
      const endMid   = padTop + 2 * total; // Ende mittlerer Satz

      if (ul.scrollTop < startMid - h) {
        ul.scrollTop += total;
      } else if (ul.scrollTop > endMid + h) {
        ul.scrollTop -= total;
      }
    }, 80);

    ul.addEventListener('scroll', onScroll, { passive: true });

    // Init
    const init = () => {
      const first = section.getAttribute('data-first-handle');
      const liToCenter = first
        ? ul.querySelector(`.aura-picker__item[data-collection-handle="${first}"]`)
        : ul.querySelector('.aura-picker__item');
      if (liToCenter) {
        const handle = liToCenter.dataset.collectionHandle;
        if (byHandle.has(handle)) setActive(handle);
      }

      if (window.matchMedia('(max-width:1023px)').matches) {
        buildInfiniteWheel();
        const target = ul.querySelector(`.aura-picker__item[aria-selected="true"]`) || ul.querySelector('.aura-picker__item');
        if (target) centerItem(target);
      }
    };

    init();

    // Bei Resize ggf. Wheel bauen (nur Handy)
    window.addEventListener('resize', debounce(() => {
      if (window.matchMedia('(max-width:1023px)').matches) buildInfiniteWheel();
    }, 200));
  });
});
